import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Waiting from '../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import valu_logoImg from './../../../statics/img/payment_methods_logos/ValU.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import './Jawwal.css';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
};
const PremiumCard = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 16 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};
const Pin = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 6 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};

class valu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            waitingHeight: '221px',
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phoneNumber: '',
            pin: '',
            pmk: '',
            reference: '',
            pin2: '',
            hideFirstStep: false,
            firstFormSubmitBtn: true,
            secondSetpShow: false,
            resendOTPDisable: false,
            countDown: 0
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.handlePinChange = this.handlePinChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePin2Change = this.handlePin2Change.bind(this);
        this.handleForm2Submit = this.handleForm2Submit.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
        this.startResendCounter = this.startResendCounter.bind(this);
    }
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
  handlePhoneNumberChange(e) {
    this.setState({phoneNumber: e.target.value});
  }
  handlePinChange(e) {
    this.setState({pin: e.target.value});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //---- send request 
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier": this.state.phoneNumber,
                "pin": this.state.pin,
                "subtype": "MPAY"
            }, 
            "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ""
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.MPAY        
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier": this.state.phoneNumber,
                "pin": this.state.pin,
                "subtype": "MPAY"
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.MPAY
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }
    paymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {        
        if(resp.data.success){
            //set pmk value & reference value and & waiting & show second form % disable first form & remove first form submit button
            this.setState({pmk: resp.data.pmk, reference: resp.data.reference, waiting: false, secondSetpShow: true, hideFirstStep: true, firstFormSubmitBtn: false},()=>{
                this.startResendCounter();
            });
            //enable payment methods
            this.props.enableAllPaymentMethods();
        } else {
            if (resp.data.url) {
                window.location.replace(resp.data.url);
                //window.location.href = resp.data.redirection_url;
            }
            if (resp.data.data.message) {
                this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message });
            } else {
                this.props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
            }
        }
    })
    .catch((err) => {
        if (err.response.data.description) {
            this.props.setReqComplete({head: '', body: err.response.data.description });
        } else {
            this.props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
        }
    });
    event.preventDefault();
  }
  handlePin2Change(e){
    this.setState({pin2: e.target.value});
  }
  handleForm2Submit(event){
    //--- strat waiting
    this.setState({waitingHeight: '289px', waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //send request
    let url= appConfig.getServerUrl() + '/api/acceptance/mpay_callback/verify_otp';
    let opt_dict = {
        "payment_token": this.state.pmk,
        "reference": this.state.reference,
        "otp": this.state.pin2
    };
    let paymentDict = JSON.stringify(opt_dict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {
        if(resp.data.success == true || resp.data.success === "true"){
            this.props.setReqComplete({head: 'Payment Successful', body:'Congratulations, your transaction completed successfully.'});
        }else{
            //succes = false
            if(resp.data.data.message){
                this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message});
            }else{
                this.props.setReqComplete({head: 'Transaction declined', body:'Please make sure that you entered the correct OTP.'});
            }
        }
    })
    .catch((err) => {
        if(err.response.data.description){
            this.props.setReqComplete({head: '', body: err.response.data.description});
        }else{
            this.props.setReqComplete({head: 'Transaction declined', body:'Please make sure that you entered the correct OTP.'});
        }
    });
    event.preventDefault();
  }
  resendOTP(e) {
    e.preventDefault();
    this.startResendCounter();
    let url= appConfig.getServerUrl() + '/api/acceptance/mpay_callback/resend_otp';
    let opt_dict = {
        "payment_token": this.state.pmk,
        "reference": this.state.reference
    };
    let paymentDict = JSON.stringify(opt_dict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {
        if(resp.data.description == "Success"){

        }else{
            this.props.setReqComplete({head: '', body:'Fail to resend new OTP.'});
        }
    })
    .catch((err) => {
        this.props.setReqComplete({head: '', body:'Fail to resend new OTP.'});
    });
  }
  startResendCounter(){
    this.setState({resendOTPDisable: true, countDown: 45},()=>{
        var resendInterval = setInterval(() => {
            if(this.state.countDown == 0){
                clearInterval(resendInterval)
                this.setState({resendOTPDisable: false})
            }else{
                let newCount = this.state.countDown - 1;
                this.setState({countDown: newCount})
            }
        }, 1000);
    });
  }
  render() {
    return (
        <div className="panel panel-default credit-card-box">
            <div className="panel-heading">
                <div className="row display-tr" >
                    <h2 className="panel-title payment-title" >Jawwal Pay Details</h2>
                </div>
            </div>
            <div className="panel-body" id="card_content">
                
                {this.state.waiting ? 
                    <Waiting height={this.state.waitingHeight} />
                :  
                    <div>
                        {this.state.hideFirstStep?
                            null
                        :
                            <Form onSubmit={this.handleSubmit}>
                                <div>
                                    <br/>
                                    <h3 className="text-center">Login To Jawwal Pay Wallet</h3>
                                    <br/>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label>Mobile Number</label>
                                                <div className="form-group">
                                                    <Input type="number" pattern="[0-9]*" className="form-control" name="c_pan_U" placeholder="05 XXX XXX XX"
                                                        value={this.state.phoneNumber} 
                                                        onChange={this.handlePhoneNumberChange}
                                                        validations={[required, PhoneNumber]}
                                                    />
                                                    <span className="input-group-addon">
                                                        <i className="glyphicon glyphicon glyphicon-phone"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label>PIN</label>
                                                <div className="form-group">
                                                    <Input type="password"  className="form-control" name="pin" placeholder="****"
                                                        value={this.state.pin}
                                                        onChange={this.handlePinChange}
                                                        validations={[required]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.firstFormSubmitBtn?
                                        <div className='text-center'>
                                            <Button className="jawwal_btn">Login</Button>
                                            <br/><br/>
                                            <h3>Don't have a Jawwal Pay Wallet ?</h3>
                                            <a className="jawwal_btn"  href="https://www.jawwalpay.ps/get-the-app" >Register Now</a>
                                        </div>
                                    :
                                        null
                                    }
                                </div>
                            </Form>
                        }
                        <Form onSubmit={this.handleForm2Submit}>
                            {this.state.secondSetpShow?
                                <div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label>Please enter One Time Pin (OTP)</label>
                                                <Input type="text" className="form-control" name="one time pin" placeholder="OTP"
                                                    value={this.state.pin2}
                                                    onChange={this.handlePin2Change}
                                                    validations={[required]} 
                                                    autoFocus={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="resendOtp">
                                        <button className="resendOtp" disabled={this.state.resendOTPDisable} onClick={this.resendOTP}>{this.state.countDown == 0 ? "Resend OTP" : "Resend OTP in " + this.state.countDown + "s"}</button>
                                    </div>
                                    <div className='text-center'>                                        
                                        <Button className="jawwal_btn">Pay</Button>
                                    </div>
                                </div>
                            :
                                null
                            }
                        </Form>
                        <br/>
                        <div className="row">
                            <div className="col-xs-12">
                                {/* <div className="col-xs-6 col-md-6 col-sm-6 text-center">
                                    <span><h5>Sponsored by</h5></span>
                                    <span><img style={{width: '50%', height: 'auto', marginLeft: '25%'}} className="img-responsive" alt="premium logo" src={valu_logoImg} /></span>
                                </div> */}
                                <div className="col-xs-12 text-center">
                                    <span><h5>Powered by</h5></span>
                                    <span><img style={{width: 'auto', height: '47px', margin: 'auto'}} className="img-responsive" alt="accept logo" src={acceptBlueImg} /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                
            </div>
        </div>
    );
  }
}

export default valu;
